/* eslint-disable no-empty */
import { queryDelegations } from './service';

const Model = {
  namespace: 'featuresAndcontactUs',
  state: {
    page: 1,
    list: [],
  },
  effects: {
    *fetch({ payload }, { call, put }) {
      yield put({
        type: 'setLoading',
        payload: true,
      });

      try {
        const response = yield call(queryDelegations, payload);
        yield put({
          type: 'queryList',
          payload: response,
        });
      } catch (error) {}
      yield put({
        type: 'setLoading',
        payload: false,
      });
    },

    *appendFetch({ payload }, { select, call, put }) {
      const requesting = yield select(({ featuresAndcontactUs }) => featuresAndcontactUs.loading);
      if (requesting) return;

      yield put({
        type: 'setLoading',
        payload: true,
      });

      try {
        const response = yield call(queryDelegations, payload);
        yield put({
          type: 'appendList',
          payload: response,
        });
      } catch (error) {}

      yield put({
        type: 'setLoading',
        payload: false,
      });
    },
  },
  reducers: {
    queryList(state, action) {
      return {
        ...state,
        list: action.payload.results,
        total: action.payload.count,
        page: 1,
      };
    },

    setLoading(state, action) {
      return {
        ...state,
        loading: action.payload,
      };
    },

    appendList(state, action) {
      return { ...state, list: state.list.concat(action.payload.results), page: state.page + 1 };
    },
  },
};
export default Model;
